import type { Bake, CustomerId, Doneness, RecipeId, SceneName, ServeLogEntry } from '../types';

export interface GameEvents {
  'state:loaded': void;
  'state:saved': void;
  'baker:changed': { costume: number };
  'recipe:selected': { recipe: RecipeId };
  'mix:changed': void;
  'menu:changed': void;
  'menu:price': { batchId: string; price: number };
  'bake:started': { bake: Bake };
  'bake:doneness': { bakeId: string; doneness: Doneness };
  'bake:finished': { bake: Bake };
  'coins:changed': { coins: number };
  'clock:tick': { gameSec: number };
  'phase:open': void;
  'phase:close': void;
  'queue:advance': { customerId: CustomerId | null };
  'serve:resolved': { entry: ServeLogEntry };
  'nav:request': { to: SceneName };
  'day:advance': { day: number };
}

type Handler<T> = (payload: T) => void;

export class EventBus {
  private handlers = new Map<keyof GameEvents, Set<Handler<unknown>>>();

  on<K extends keyof GameEvents>(event: K, handler: Handler<GameEvents[K]>): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler as Handler<unknown>);
    return () => set!.delete(handler as Handler<unknown>);
  }

  emit<K extends keyof GameEvents>(event: K, payload: GameEvents[K]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const h of set) (h as Handler<GameEvents[K]>)(payload);
  }
}

export const events = new EventBus();
